import { MCSSelectedProductVariants } from './productTileCollection'

export class ProductVariantHandler {
  /**
   * Extracts product variant selections, excluding Quantity
   */
  static getSelections(variants: MCSSelectedProductVariants | undefined): Record<string, string> {
    if (!variants) return {}

    return Object.fromEntries(
      Object.entries(variants).filter(([key, value]) => key !== 'Quantity' && value !== undefined)
    )
  }

  /**
   * Safely extracts quantity as a number
   */
  static getQuantity(variants: MCSSelectedProductVariants | undefined): number | undefined {
    const quantity = variants?.Quantity
    return quantity ? Number(quantity) : undefined
  }
}
